import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {CustomSelect} from '../../../common/components/StyledComp';
import {flowRight as compose} from 'lodash';
import moment from 'moment';

const MonthPicker = ({t, onChange, value, ...props}) => {

  let months = [];

  for (let i = 1; i <= 12; i++) {
    months.push(<option value={i} key={i}>{(moment().month(i - 1).format('MMMM'))}</option>);
  }

  return (
    <CustomSelect
      name="months"
      onChange={onChange}
      value={value}
      absolute
      {...props}>
      {months}
    </CustomSelect>
  );
};

MonthPicker.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
};

export default compose(
  withTranslation('common'),
)(MonthPicker);

